import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { IControl } from '@eureka/utils/control'
import type { AgentUploadLimitStrategy } from './agent-upload-limit-strategy'

@injectable()
export class SarUploadLimitStrategy implements AgentUploadLimitStrategy {
    getLimit(controlInfo?: IControl): number | undefined {
        const { ls_role, ls_plg_role } = controlInfo ?? {}
        if (ls_role) {
            return (ls_role === 'trial' || ls_role === 'commercial') ? 10 : 2
        }
        if (ls_plg_role === 'personal_pro') return 2
        if (ls_plg_role === 'personal_basic') return 2
        return undefined
    }
}
